// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"565":"component---src-templates-page-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"565":"79927d5ff682055b1353","731":"ff22b8340c514b316caf","843":"e07f05a60c64caa577ae","883":"c3e7ed52e4a48d86f164"}[chunkId] + ".js";
};